import { useState } from 'react'
import { Row, Col, Modal, Button } from 'antd'
import { Parser } from 'html-to-react'
import useTranslation from '@/hooks/useTranslation'
import { useDispatch, useSelector } from 'react-redux'
import { uploadMissingInfo } from '../../../../redux/requestSlice'
import { errorHandling, openNotification } from '../../../../utils/utils'

import TextArea from '../../form/TextArea'
import Upload from '../../form/UploadGeneral'
import Close from '../../../svgs/CloseModal'
import UploadedFile from '../../UploadedFile'

const htmlToReactParser = new Parser()

export default function UploadMissingInfo({ open, setOpen, id, notes }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { loading } = useSelector((state) => state.request)

  const [missing_info, setMissing_info] = useState('')
  const [files, setFiles] = useState([])

  const handleFileUpload = ({ fileList }) => {
    setFiles(fileList)
  }

  const handleSubmit = () => {
    let formData = new FormData()

    formData.set('service_request_id', id)
    formData.set('missing_info', missing_info)
    for (let i = 0; i < files.length; i++) {
      formData.append('files[]', files[i].originFileObj)
    }

    dispatch(uploadMissingInfo(formData))
      .unwrap()
      .then((data) => {
        openNotification('success', data.message)
        setOpen(false)
        setMissing_info(null)
        setFiles([])
      })
      .catch((error) => openNotification('error', errorHandling(error)))
  }

  return (
    <Modal
      className='!w-[50rem]'
      title={null}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      closable={false}
      centered
    >
      <div className='flex items-center justify-between mb-24'>
        <h3 className='text-gray text-xl font-semibold'>
          {t('Upload Missing Info')}
        </h3>
        <Close style='cursor-pointer w-20' onClick={() => setOpen(false)} />
      </div>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          {notes?.map((ele, i) => (
            <div
              key={i}
              className='mb-16 last:mb-0 border-b border-[#DDD] last:border-b-0 pb-16 last-pb-0'
            >
              <div className='text-[#6D6D6D] text-sm leading-8 mb-8'>
                {htmlToReactParser.parse(ele.info)}
              </div>

              <div className='info'>
                <p className='text-black text-sm font-semibold'>
                  <span className='text-green'>{t('Added At')}:</span>{' '}
                  {ele.created_at?.substr(0, 10).split('-').reverse().join('-')}
                </p>
              </div>
            </div>
          ))}
        </Col>
        <Col xs={24} lg={12}>
          <div className='form-type_5'>
            <TextArea
              rows={8}
              label={t('Notes')}
              name='missing_info'
              value={missing_info}
              onChange={(e) => setMissing_info(e.target.value)}
              style='mb-24'
            />

            <Upload
              label={t('Attachments')}
              hint={t('Choose File to Upload')}
              fileList={files}
              onChange={handleFileUpload}
            />
            {files.length ? (
              <div className='flex flex-wrap items-center mt-12'>
                {files.map((ele, i) => (
                  <UploadedFile
                    key={i}
                    filename={ele.name}
                    onDelete={() => {
                      const updatedArr = files.filter(
                        (file) => file.uid !== ele.uid
                      )
                      setFiles(updatedArr)
                    }}
                  />
                ))}
              </div>
            ) : null}
          </div>
        </Col>
      </Row>

      <div className='flex items-center justify-between mt-24'>
        <Button
          className='btn-text-gray text-base'
          onClick={() => setOpen(false)}
        >
          {t('form.btn.cancel')}
        </Button>
        <Button
          className='btn-green text-base rounded-md py-12 px-50 h-auto'
          loading={loading}
          onClick={handleSubmit}
        >
          {t('form.btn.submit')}
        </Button>
      </div>
    </Modal>
  )
}
